import { makeStyles } from '@material-ui/styles';
import React from 'react';

const useStyles = makeStyles({
    circle: {
        width: 100,
        height: 100,
        lineHeight: 100,
        borderRadius: '50%',
        opacity: 0.7,
        textAlign: 'center',
        color: 'white',
        fontSize: '16px',
        textTransform: 'uppercase',
        fontWeight: 700,
        margin: '0 auto 40px',
        border: '5px solid #000080',
        
    },
    logo: {
        fontFamily: 'Staatliches',
    }
});

export const Logo = () => {
    const classes = useStyles();
    return <h2 className={classes.logo}>CRYPTO BROADWAY</h2>
};

